module.exports = __webpack_public_path__ + "static/media/doc06.78995aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc06.png
// module id = 58
// module chunks = 0